module.exports = __webpack_public_path__ + "img/limiting.854da343.svg";